export const l10nDe = {
    general: {
        dateTime: {
            date: 'Datum',
            time: 'Uhrzeit',
            dateTime: 'Datum und Uhrzeit',
            startDate: 'Startdatum',
            endDate: 'Enddatum',
            createdAt: 'Erstellt am',
            updatedAt: 'Zuletzt geändert am',
            today: 'Heute',
            yesterday: 'Gestern',
            tomorrow: 'Morgen',
            now: 'Jetzt',
            never: 'Nie',
            allDay: 'Ganztägig',
            duration: 'Dauer',
            estimatedDuration:'Erwartete Dauer',
            actualDuration:'Tatsächliche Dauer',
        },

        common: {
            id: 'ID',
            name: 'Name',
            title: 'Titel',
            description: 'Beschreibung',
            type: 'Typ',
            status: 'Status',
            state: 'Zustand',
            category: 'Kategorie',
            priority: 'Priorität',
            value: 'Wert',
            number: 'Nummer',
            code: 'Code',
            color: 'Farbe',
            label: 'Bezeichnung',
            note: 'Notiz',
            notes: 'Notizen',
            comment: 'Kommentar',
            comments: 'Kommentare',
            details: 'Details',
            information: 'Informationen',
            settings: 'Einstellungen',
            options: 'Optionen',
            properties: 'Eigenschaften',
            items: 'Einträge',
            total: 'Gesamt',
            count: 'Anzahl',
            amount: 'Menge',
            unknown: 'Unbekannt',
            none: 'Keine',
            empty: 'Leer',
            all: 'Alle',
            yes: 'Ja',
            no: 'Nein',
            existing:''
        },

        actions: {
            add: 'Hinzufügen',
            create: 'Erstellen',
            edit: 'Bearbeiten',
            update: 'Aktualisieren',
            delete: 'Löschen',
            remove: 'Entfernen',
            save: 'Speichern',
            cancel: 'Abbrechen',
            close: 'Schließen',
            confirm: 'Bestätigen',
            apply: 'Anwenden',
            reset: 'Zurücksetzen',
            clear: 'Leeren',
            refresh: 'Aktualisieren',
            reload: 'Neu laden',
            search: 'Suchen',
            filter: 'Filtern',
            sort: 'Sortieren',
            select: 'Auswählen',
            deselect: 'Auswahl aufheben',
            selectAll: 'Alle auswählen',
            deselectAll: 'Auswahl aufheben',
            open: 'Öffnen',
            view: 'Anzeigen',
            preview: 'Vorschau',
            download: 'Herunterladen',
            upload: 'Hochladen',
            import: 'Importieren',
            export: 'Exportieren',
            copy: 'Kopieren',
            duplicate: 'Duplizieren',
            move: 'Verschieben',
            back: 'Zurück',
            next: 'Weiter',
            previous: 'Zurück',
            submit: 'Absenden',
            retry: 'Erneut versuchen',
        },

        status: {
            active: 'Aktiv',
            inactive: 'Inaktiv',
            enabled: 'Aktiviert',
            disabled: 'Deaktiviert',
            pending: 'Ausstehend',
            draft: 'Entwurf',
            new: 'Neu',
            open: 'Offen',
            closed: 'Geschlossen',
            completed: 'Abgeschlossen',
            cancelled: 'Abgebrochen',
            failed: 'Fehlgeschlagen',
            successful: 'Erfolgreich',
            loading: 'Wird geladen',
            processing: 'Wird verarbeitet',
            available: 'Verfügbar',
            unavailable: 'Nicht verfügbar',
        },

        validation: {
            required: 'Dieses Feld ist erforderlich.',
            invalid: 'Ungültiger Wert.',
            invalidFormat: 'Ungültiges Format.',
            tooShort: 'Der Wert ist zu kurz.',
            tooLong: 'Der Wert ist zu lang.',
            minValue: 'Der Wert ist zu klein.',
            maxValue: 'Der Wert ist zu groß.',
            invalidEmail: 'Ungültige E-Mail-Adresse.',
            invalidDate: 'Ungültiges Datum.',
            invalidTime: 'Ungültige Uhrzeit.',
            passwordsDoNotMatch: 'Die Passwörter stimmen nicht überein.',
            valueAlreadyExists: 'Dieser Wert existiert bereits.',
        },

        messages: {
            success: 'Vorgang erfolgreich abgeschlossen.',
            error: 'Ein Fehler ist aufgetreten.',
            warning: 'Achtung.',
            info: 'Information',
            noResults: 'Keine Ergebnisse gefunden.',
            noData: 'Keine Daten verfügbar.',
            noItems: 'Keine Einträge vorhanden.',
            loading: 'Daten werden geladen...',
            saving: 'Daten werden gespeichert...',
            deleting: 'Daten werden gelöscht...',
            saved: 'Erfolgreich gespeichert.',
            deleted: 'Erfolgreich gelöscht.',
            changesSaved: 'Änderungen wurden gespeichert.',
            unsavedChanges: 'Es gibt ungespeicherte Änderungen.',
            confirmDelete: 'Möchten Sie diesen Eintrag wirklich löschen?',
            confirmDiscard: 'Möchten Sie die Änderungen wirklich verwerfen?',
            operationFailed: 'Der Vorgang konnte nicht abgeschlossen werden.',
        },

        navigation: {
            home: 'Startseite',
            dashboard: 'Dashboard',
            overview: 'Übersicht',
            details: 'Details',
            list: 'Liste',
            form: 'Formular',
            menu: 'Menü',
            actions: 'Aktionen',
            more: 'Mehr',
            less: 'Weniger',
            expand: 'Erweitern',
            collapse: 'Reduzieren',
            first: 'Erste',
            last: 'Letzte',
            page: 'Seite',
            of: 'von',
        },

        search: {
            search: 'Suche',
            searchPlaceholder: 'Suchen...',
            searchFor: 'Suchen nach',
            noResults: 'Keine Ergebnisse gefunden.',
            results: 'Ergebnisse',
            clear: 'Suche löschen',
            filters: 'Filter',
            activeFilters: 'Aktive Filter',
            clearFilters: 'Filter zurücksetzen',
        },

        pagination: {
            page: 'Seite',
            of: 'von',
            first: 'Erste Seite',
            previous: 'Vorherige Seite',
            next: 'Nächste Seite',
            last: 'Letzte Seite',
            itemsPerPage: 'Einträge pro Seite',
            showing: 'Zeige',
            to: 'bis',
            total: 'von insgesamt',
        },

        sorting: {
            sortBy: 'Sortieren nach',
            ascending: 'Aufsteigend',
            descending: 'Absteigend',
            unsorted: 'Nicht sortiert',
        },

        filters: {
            filterBy: 'Filtern nach',
            equals: 'Ist gleich',
            notEquals: 'Ist nicht gleich',
            contains: 'Enthält',
            notContains: 'Enthält nicht',
            startsWith: 'Beginnt mit',
            endsWith: 'Endet mit',
            greaterThan: 'Größer als',
            lessThan: 'Kleiner als',
            greaterThanOrEqual: 'Größer oder gleich',
            lessThanOrEqual: 'Kleiner oder gleich',
            between: 'Zwischen',
            isEmpty: 'Ist leer',
            isNotEmpty: 'Ist nicht leer',
        },

        permissions: {
            access: 'Zugriff',
            read: 'Lesen',
            write: 'Schreiben',
            create: 'Erstellen',
            update: 'Bearbeiten',
            delete: 'Löschen',
            view: 'Anzeigen',
            manage: 'Verwalten',
            allowed: 'Erlaubt',
            denied: 'Verweigert',
            noPermission: 'Keine Berechtigung.',
        },

        files: {
            file: 'Datei',
            files: 'Dateien',
            attachment: 'Anhang',
            attachments: 'Anhänge',
            upload: 'Hochladen',
            download: 'Herunterladen',
            fileName: 'Dateiname',
            fileSize: 'Dateigröße',
            fileType: 'Dateityp',
            chooseFile: 'Datei auswählen',
            noFile: 'Keine Datei ausgewählt.',
            invalidFileType: 'Nicht unterstützter Dateityp.',
            fileTooLarge: 'Die Datei ist zu groß.',
        },

        user: {
            user: 'Benutzer',
            users: 'Benutzer',
            account: 'Konto',
            profile: 'Profil',
            email: 'E-Mail',
            phone: 'Telefon',
            firstName: 'Vorname',
            lastName: 'Nachname',
            fullName: 'Vollständiger Name',
            username: 'Benutzername',
            password: 'Passwort',
            newPassword: 'Neues Passwort',
            confirmPassword: 'Passwort bestätigen',
            language: 'Sprache',
            role: 'Rolle',
        },

        boolean: {
            yes: 'Ja',
            no: 'Nein',
            true: 'Ja',
            false: 'Nein',
        },

        units: {
            day: 'Tag',
            days: 'Tage',
            hour: 'Stunde',
            hours: 'Stunden',
            minute: 'Minute',
            minutes: 'Minuten',
            second: 'Sekunde',
            seconds: 'Sekunden',
            byte: 'Byte',
            bytes: 'Bytes',
            kilobyte: 'KB',
            megabyte: 'MB',
            gigabyte: 'GB',
            percent: '%',
        },
    },
    admin: {
        companySettings: {
            eyebrow:'Firma',
            title:'Generelle Firmen Einstellungen ',
            description:'Generelle einstellungen zur eigen Firma',
        },
        role:{
            managePermissions:'Berechtigungsmatrix',
            sumPermission:'Berechtigungsanzahl'
        }
    },
    crm: {
        project: {
            formSections:{
                timeTrackingEntrySettings: 'Einstellungen Für Zeiterfassung'
            },
            form:{
                requireEfforts:'Aufwände Erforderlich',
            }
        },
        task: {
            shared: {
                title:'Aufgaben',
                effort:'Aufwand',
                effortType: 'Aufwandstyp'
            },
            list: {
                projectRequiresEfforts:'Projekt Bedingt Aufwände',
                effortsPresent:'Aufwände Vorhanden',
                effortsMissing:'Aufwände Fehlen',
                effortsNotRequired:'Nicht Notwendig'
            },
            form: {
                efforts:{
                    heading:'Aufwände',
                    addEffortType: 'Aufwandstyp Hinzufügen'
                }
            },
            effortTyp:{
              existingEfforts:'Persistierte Aufwandstypen'
            },
            relation:{
                block:'Ist Geblockt von',
                dependency:'Ist Abhängig von',
                parentChild:'Ist Child von',
                relatedTo:'Ist Verwandt mit',
                duplication:'Ist Duplikat von',
                clone:'Ist Klon von',
                succession:'Folgt',
                fromTask:'Von Aufgabe',
                toTask:'Zu Aufgabe',
                connection:'Verbindung'
            }
        },
        companies: {
            logo:'Firmen Logo',
            uploadLogo:'Logo Hochladen',
        },
        contacts: {},
        workflow: {}
    }
}